import 'video-react/dist/video-react.css';
import React, { useRef } from 'react';
import { Player } from 'video-react';

function VideoPlayerBox({videourl,thumb}) {
  const baseUrl = process.env.REACT_APP_BASEURL;

  return (
    // 'Player' component from video-react is used to play the video
    <div className='flex justify-center w-full h-full'>
      <div className='md:w-9/12 w-11/12' style={{height:'100%'}}>
        <Player
          // loading="lazy"
        //   ref={playerRef}
          aspectRatio='16:9'
          poster={`${baseUrl}${thumb}`}
          width={'100%'}
          height={'100%'}
         
        >
          <source src={videourl} />
        </Player>
        {/* <button onClick={jumpToTime}>Jumb to Second 10</button> */}
      </div>

    </div>
  )
}

export default VideoPlayerBox